(function () {
    'use strict';

    angular
        .module('app')
        .factory('DashboardSettingsService', DashboardSettingsService);

    DashboardSettingsService.$inject = ['$http', 'DataService', 'UrlService', ];

    function DashboardSettingsService($http, DataService, UrlService) {
        var service = {};

        angular.extend(service, DataService('dashboardsetting'));

        angular.extend(service, {
            count: count
        });

        return service;

        /**
         * Gets the count of dashboard settings
         *
         * @param {bool} deleted
         * @returns {promise} A promise that resolves with the count
         */
        function count(deleted) {
            var url = UrlService.getWebAPIUrl() + '/dashboardsetting/count';

            if (!_.isNil(deleted)) {
                url += '?deleted=' + deleted;
            }

            return $http.get(url).then(
                function (response) {
                    return response.data;
                });
        }
    }
})();